<template>
  <div :class="$style.hint">
    <div :class="$style.iconContainer">
      <HgIcon :icon="icon" theme="secondary" size="large" :class="$style.icon" />
    </div>
    <p v-if="hasSlot"><slot></slot></p>
    <p>{{ hintText }}</p>
  </div>
</template>

<script setup lang="ts">
import { HgIcon, Icon } from '@smg-real-estate/domus';
import { type PropType } from 'vue';

const { hasSlot, hintText, icon } = defineProps({
  hasSlot: {
    type: Boolean,
    default: false,
  },
  hintText: {
    type: String,
    required: true,
    default: '',
  },
  icon: {
    type: String as PropType<`${Icon}`>,
    required: true,
  },
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

.hint {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  padding: $space-100;
  background-color: $color-sky-10;
  border-radius: $border-radius-l;

  .iconContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: $space-200;
    height: $space-200;
    background-color: $color-sky-30;
    border-radius: 50%;

    .icon {
      margin-bottom: 2px;
    }
  }

  p {
    @include body-3;

    & {
      margin: 0 $space-100;
    }
  }
}
</style>
